import { apiUrl } from '../../../../settings'
export const addAdminUserUrl = () => {
  return apiUrl + '/addAdminUser'
}
